export enum QuotesApiActionTypes {
  LoadQuotesSuccess = '[Quotes API] Load Quotes Success',
  LoadQuotesFailure = '[Quotes API] Load Quotes Failure',

  LoadQuoteSuccess = '[Quotes API] Load Quote Success',
  LoadQuoteWithPropFormSuccess = '[Quotes API] Load Quote With Prop Form Success',
  LoadQuoteFailure = '[Quotes API] Load Quote Failure',

  LoadClientQuotesSuccess = '[Quotes API] Load Client Quotes Success',
  LoadClientQuotesWithLiveCheckSuccess = '[Quotes API] Load Client Quotes With Live Check Success',
  LoadClientQuotesFailure = '[Quotes API] Load Client Quotes Failure',

  LoadQuotesForContactDashboardSuccess = '[Quotes API] Load Quotes For Contact Dashboard Success',
  LoadQuotesForContactDashboardFailure = '[Quotes API] Load Quotes For Contact Dashboard Failure',

  QuoteApprovedSuccess = '[Quotes API] Quote Approved Success',
  QuoteApprovedFailure = '[Quotes API] Quote Approved Failure',

  QuoteReleasedSuccess = '[Quotes API] Quote Released Success',
  QuoteReleasedFailure = '[Quotes API] Quote Released Failure',

  QuoteCompletedSuccess = '[Quotes API] Quote Completed Success',
  QuoteCompletedFailure = '[Quotes API] Quote Completed Failure',

  ChangesRequestedSuccess = '[Quotes API] Changes Requested Success',
  ChangesRequestedFailure = '[Quotes API] Changes Requested Failure',

  BrokerAssignedSuccess = '[Quotes API] Broker Assigned Success',
  BrokerAssignedFailure = '[Quotes API] Broker Assigned Failure',

  EndorsementSubmittedSuccess = '[Quotes API] Endorsement Submitted Success',
  EndorsementSubmittedFailure = '[Quotes API] Endorsement Submitted Failure',

  UpdateStatusSuccess = '[Quotes API] Update Status Success',
  UpdateStatusFailure = '[Quotes API] Update Status Failure',

  TierSelectedSuccess = '[Quotes API] Select Tier Success',
  TierSelectedFailure = '[Quotes API] Select Tier Failure',

  TierAdjustedSuccess = '[Quotes API] Adjust Tier Success',
  TierAdjustedFailure = '[Quotes API] Adjust Tier Failure',

  AdjustmentsAppliedSuccess = '[Quotes API] Adjustments Applied Success',
  AdjustmentsAppliedFailure = '[Quotes API] Adjustments Applied Failure',

  EndorsementsUpdatedSuccess = '[Quotes API] Endorsements Updated Success',
  EndorsementsUpdatedFailure = '[Quotes API] Endorsements Updated Failure',

  AddonToggledSuccess = '[Quotes API] Addon Toggled Success',
  AddonToggledFailure = '[Quotes API] Addon Toggled Failure',

  AddonAdjustedSuccess = '[Quotes API] Addon Adjusted Success',
  AddonAdjustedFailure = '[Quotes API] Addon Adjusted Failure',

  InitialisedSuccess = '[Quotes API] Quote Initialised Success',
  InitialisedFailure = '[Quotes API] Quote Initialised Failure',

  ReconfiguredSuccess = '[Quotes API] Quote Reconfigured Success',
  ReconfiguredFailure = '[Quotes API] Quote Reconfigured Failure',

  Reconfigured2Success = '[Quotes API] Quote Reconfigured V2 Success',
  Reconfigured2Failure = '[Quotes API] Quote Reconfigured V2 Failure',

  ChecklistUpdatedSuccess = '[Quotes API] Checklist Updated Success',
  ChecklistUpdatedFailure = '[Quotes API] Checklist Updated Failure',

  ProposalUpdatedSuccess = '[Quotes API] Proposal Updated Success',
  ProposalUpdatedFailure = '[Quotes API] Proposal Updated Failure',

  ProposalAutoSavedSuccess = '[Quotes API] Proposal Auto Saved Success',
  ProposalAutoSavedFailure = '[Quotes API] Proposal Auto Saved Failure',

  ProposalStepSubmitSuccess = '[Quotes API] Proposal Step Submit Success',
  ProposalStepSubmitFailure = '[Quotes API] Proposal Step Submit Failure',

  ProposalBackupSavedSuccess = '[Quotes API] Proposal Backup Saved Success',
  ProposalBackupSavedFailure = '[Quotes API] Proposal Backup Saved Failure',

  ProposalSubmittedSuccess = '[Quotes API] Proposal Submitted Success',
  ProposalSubmittedFailure = '[Quotes API] Proposal Submitted Failure',

  SendRenewalInviteSuccess = '[Quotes API] Send Renewal Invite Success',
  SendRenewalInviteFailure = '[Quotes API] Send Renewal Invite Failure',

  ProposalReturnedSuccess = '[Quotes API] Proposal Returned Success',
  ProposalReturnedFailure = '[Quotes API] Proposal Returned Failure',

  HoldSuccess = '[Quotes API] Hold Success',
  HoldFailure = '[Quotes API] Hold Failure',

  QuoteRequestedSuccess = '[Quotes API] Quote Requested Success',
  QuoteRequestedFailure = '[Quotes API] Quote Requested Failure',

  RequotedSuccess = '[Quotes API] Requoted Success',
  RequotedFailure = '[Quotes API] Requoted Failure',

  QuoteReadySuccess = '[Quotes API] QuoteReady Success',
  QuoteReadyFailure = '[Quotes API] QuoteReady Failure',

  SendToClientSuccess = '[Quotes API] Send To Client Success',
  SendToClientFailure = '[Quotes API] Send To Client Failure',

  AcceptSuccess = '[Quotes API] Accept Success',
  AcceptFailure = '[Quotes API] Accept Failure',

  SetPaymentTypeSuccess = '[Quotes API] Set Payment Type Success',
  SetPaymentTypeFailure = '[Quotes API] Set Payment Type Failure',

  InvoiceSuccess = '[Quotes API] Invoice Success',
  InvoiceFailure = '[Quotes API] Invoice Failure',

  PaymentReceivedSuccess = '[Quotes API] Payment Received Success',
  PaymentReceivedFailure = '[Quotes API] Payment Received Failure',

  CompleteSuccess = '[Quotes API] Complete Success',
  CompleteFailure = '[Quotes API] Complete Failure',

  NotTakenUpSuccess = '[Quotes API] Not Taken Up Success',
  NotTakenUpFailure = '[Quotes API] Not Taken Up Failure',

  ContactsAssignedSuccess = '[Quotes API] Contacts Assigned Success',
  ContactsAssignedFailure = '[Quotes API] Contacts Assigned Failure',
}
